export enum EmptyStateType {
  nothingToShow = 'nothingToShow',
  dataProcessing = 'dataProcessing',
  dataNotAvailableError = 'dataNotAvailableError',
  actionRequired = 'actionRequired',
  pageNotFound = 'pageNotFound',
  success = 'success',
  ufoLoader = 'ufoLoader'
}

export enum EmptyStateSize {
  tiny = 'tiny',
  small = 'small',
  medium = 'medium',
  intermediate = 'intermediate',
  large = 'large'
}
